var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLearnBg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 380,
    height: 200,
    viewBox: "0 0 380 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 167H380",
    stroke: "#E5E7EB",
    strokeWidth: 1.14908,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M296 167L296 -4.59826e-07",
    stroke: "#E5E7EB",
    strokeWidth: 1.14908,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M296 172L296 176",
    stroke: "#E5E7EB",
    strokeWidth: 1.14908,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M296 180L296 184",
    stroke: "#E5E7EB",
    strokeWidth: 1.14908,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    clipPath: "url(#clip0_862_5384)"
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M302.892 101.554C303.179 101.554 303.412 101.321 303.412 101.034C303.412 100.747 303.179 100.514 302.892 100.514C302.604 100.514 302.371 100.747 302.371 101.034C302.371 101.321 302.604 101.554 302.892 101.554Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M310.768 101.554C311.055 101.554 311.288 101.321 311.288 101.034C311.288 100.747 311.055 100.514 310.768 100.514C310.481 100.514 310.248 100.747 310.248 101.034C310.248 101.321 310.481 101.554 310.768 101.554Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M318.57 101.554C318.857 101.554 319.09 101.321 319.09 101.034C319.09 100.747 318.857 100.514 318.57 100.514C318.282 100.514 318.049 100.747 318.049 101.034C318.049 101.321 318.282 101.554 318.57 101.554Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M326.446 101.554C326.733 101.554 326.966 101.321 326.966 101.034C326.966 100.747 326.733 100.514 326.446 100.514C326.159 100.514 325.926 100.747 325.926 101.034C325.926 101.321 326.159 101.554 326.446 101.554Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M334.322 101.554C334.609 101.554 334.842 101.321 334.842 101.034C334.842 100.747 334.609 100.514 334.322 100.514C334.035 100.514 333.802 100.747 333.802 101.034C333.802 101.321 334.035 101.554 334.322 101.554Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M342.124 101.554C342.411 101.554 342.644 101.321 342.644 101.034C342.644 100.747 342.411 100.514 342.124 100.514C341.837 100.514 341.604 100.747 341.604 101.034C341.604 101.321 341.837 101.554 342.124 101.554Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M350 101.554C350.287 101.554 350.52 101.321 350.52 101.034C350.52 100.747 350.287 100.514 350 100.514C349.713 100.514 349.48 100.747 349.48 101.034C349.48 101.321 349.713 101.554 350 101.554Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M357.802 101.554C358.089 101.554 358.322 101.321 358.322 101.034C358.322 100.747 358.089 100.514 357.802 100.514C357.515 100.514 357.282 100.747 357.282 101.034C357.282 101.321 357.515 101.554 357.802 101.554Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M365.678 101.554C365.965 101.554 366.198 101.321 366.198 101.034C366.198 100.747 365.965 100.514 365.678 100.514C365.391 100.514 365.158 100.747 365.158 101.034C365.158 101.321 365.391 101.554 365.678 101.554Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M373.554 101.554C373.841 101.554 374.074 101.321 374.074 101.034C374.074 100.747 373.841 100.514 373.554 100.514C373.267 100.514 373.034 100.747 373.034 101.034C373.034 101.321 373.267 101.554 373.554 101.554Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M302.892 93.7523C303.179 93.7523 303.412 93.5195 303.412 93.2322C303.412 92.945 303.179 92.7121 302.892 92.7121C302.604 92.7121 302.371 92.945 302.371 93.2322C302.371 93.5195 302.604 93.7523 302.892 93.7523Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M310.768 93.7523C311.055 93.7523 311.288 93.5195 311.288 93.2322C311.288 92.945 311.055 92.7121 310.768 92.7121C310.481 92.7121 310.248 92.945 310.248 93.2322C310.248 93.5195 310.481 93.7523 310.768 93.7523Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M318.57 93.7523C318.857 93.7523 319.09 93.5195 319.09 93.2322C319.09 92.945 318.857 92.7121 318.57 92.7121C318.282 92.7121 318.049 92.945 318.049 93.2322C318.049 93.5195 318.282 93.7523 318.57 93.7523Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M326.446 93.7523C326.733 93.7523 326.966 93.5195 326.966 93.2322C326.966 92.945 326.733 92.7121 326.446 92.7121C326.159 92.7121 325.926 92.945 325.926 93.2322C325.926 93.5195 326.159 93.7523 326.446 93.7523Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M334.322 93.7523C334.609 93.7523 334.842 93.5195 334.842 93.2322C334.842 92.945 334.609 92.7121 334.322 92.7121C334.035 92.7121 333.802 92.945 333.802 93.2322C333.802 93.5195 334.035 93.7523 334.322 93.7523Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M342.124 93.7523C342.411 93.7523 342.644 93.5195 342.644 93.2322C342.644 92.945 342.411 92.7121 342.124 92.7121C341.837 92.7121 341.604 92.945 341.604 93.2322C341.604 93.5195 341.837 93.7523 342.124 93.7523Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M350 93.7523C350.287 93.7523 350.52 93.5195 350.52 93.2322C350.52 92.945 350.287 92.7121 350 92.7121C349.713 92.7121 349.48 92.945 349.48 93.2322C349.48 93.5195 349.713 93.7523 350 93.7523Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M357.802 93.7523C358.089 93.7523 358.322 93.5195 358.322 93.2322C358.322 92.945 358.089 92.7121 357.802 92.7121C357.515 92.7121 357.282 92.945 357.282 93.2322C357.282 93.5195 357.515 93.7523 357.802 93.7523Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M365.678 93.7523C365.965 93.7523 366.198 93.5195 366.198 93.2322C366.198 92.945 365.965 92.7121 365.678 92.7121C365.391 92.7121 365.158 92.945 365.158 93.2322C365.158 93.5195 365.391 93.7523 365.678 93.7523Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M373.554 93.7523C373.841 93.7523 374.074 93.5195 374.074 93.2322C374.074 92.945 373.841 92.7121 373.554 92.7121C373.267 92.7121 373.034 92.945 373.034 93.2322C373.034 93.5195 373.267 93.7523 373.554 93.7523Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M302.892 85.8762C303.179 85.8762 303.412 85.6433 303.412 85.3561C303.412 85.0688 303.179 84.8359 302.892 84.8359C302.604 84.8359 302.371 85.0688 302.371 85.3561C302.371 85.6433 302.604 85.8762 302.892 85.8762Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M310.768 85.8762C311.055 85.8762 311.288 85.6433 311.288 85.3561C311.288 85.0688 311.055 84.8359 310.768 84.8359C310.481 84.8359 310.248 85.0688 310.248 85.3561C310.248 85.6433 310.481 85.8762 310.768 85.8762Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M318.57 85.8762C318.857 85.8762 319.09 85.6433 319.09 85.3561C319.09 85.0688 318.857 84.8359 318.57 84.8359C318.282 84.8359 318.049 85.0688 318.049 85.3561C318.049 85.6433 318.282 85.8762 318.57 85.8762Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M326.446 85.8762C326.733 85.8762 326.966 85.6433 326.966 85.3561C326.966 85.0688 326.733 84.8359 326.446 84.8359C326.159 84.8359 325.926 85.0688 325.926 85.3561C325.926 85.6433 326.159 85.8762 326.446 85.8762Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M334.322 85.8762C334.609 85.8762 334.842 85.6433 334.842 85.3561C334.842 85.0688 334.609 84.8359 334.322 84.8359C334.035 84.8359 333.802 85.0688 333.802 85.3561C333.802 85.6433 334.035 85.8762 334.322 85.8762Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M342.124 85.8762C342.411 85.8762 342.644 85.6433 342.644 85.3561C342.644 85.0688 342.411 84.8359 342.124 84.8359C341.837 84.8359 341.604 85.0688 341.604 85.3561C341.604 85.6433 341.837 85.8762 342.124 85.8762Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M350 85.8762C350.287 85.8762 350.52 85.6433 350.52 85.3561C350.52 85.0688 350.287 84.8359 350 84.8359C349.713 84.8359 349.48 85.0688 349.48 85.3561C349.48 85.6433 349.713 85.8762 350 85.8762Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M357.802 85.8762C358.089 85.8762 358.322 85.6433 358.322 85.3561C358.322 85.0688 358.089 84.8359 357.802 84.8359C357.515 84.8359 357.282 85.0688 357.282 85.3561C357.282 85.6433 357.515 85.8762 357.802 85.8762Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M365.678 85.8762C365.965 85.8762 366.198 85.6433 366.198 85.3561C366.198 85.0688 365.965 84.8359 365.678 84.8359C365.391 84.8359 365.158 85.0688 365.158 85.3561C365.158 85.6433 365.391 85.8762 365.678 85.8762Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M373.554 85.8762C373.841 85.8762 374.074 85.6433 374.074 85.3561C374.074 85.0688 373.841 84.8359 373.554 84.8359C373.267 84.8359 373.034 85.0688 373.034 85.3561C373.034 85.6433 373.267 85.8762 373.554 85.8762Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M302.892 78C303.179 78 303.412 77.7672 303.412 77.4799C303.412 77.1926 303.179 76.9598 302.892 76.9598C302.604 76.9598 302.371 77.1926 302.371 77.4799C302.371 77.7672 302.604 78 302.892 78Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M310.768 78C311.055 78 311.288 77.7672 311.288 77.4799C311.288 77.1926 311.055 76.9598 310.768 76.9598C310.481 76.9598 310.248 77.1926 310.248 77.4799C310.248 77.7672 310.481 78 310.768 78Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M318.57 78C318.857 78 319.09 77.7672 319.09 77.4799C319.09 77.1926 318.857 76.9598 318.57 76.9598C318.282 76.9598 318.049 77.1926 318.049 77.4799C318.049 77.7672 318.282 78 318.57 78Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M326.446 78C326.733 78 326.966 77.7672 326.966 77.4799C326.966 77.1926 326.733 76.9598 326.446 76.9598C326.159 76.9598 325.926 77.1926 325.926 77.4799C325.926 77.7672 326.159 78 326.446 78Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M334.322 78C334.609 78 334.842 77.7672 334.842 77.4799C334.842 77.1926 334.609 76.9598 334.322 76.9598C334.035 76.9598 333.802 77.1926 333.802 77.4799C333.802 77.7672 334.035 78 334.322 78Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M342.124 78C342.411 78 342.644 77.7672 342.644 77.4799C342.644 77.1926 342.411 76.9598 342.124 76.9598C341.837 76.9598 341.604 77.1926 341.604 77.4799C341.604 77.7672 341.837 78 342.124 78Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M350 78C350.287 78 350.52 77.7672 350.52 77.4799C350.52 77.1926 350.287 76.9598 350 76.9598C349.713 76.9598 349.48 77.1926 349.48 77.4799C349.48 77.7672 349.713 78 350 78Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M357.802 78C358.089 78 358.322 77.7672 358.322 77.4799C358.322 77.1926 358.089 76.9598 357.802 76.9598C357.515 76.9598 357.282 77.1926 357.282 77.4799C357.282 77.7672 357.515 78 357.802 78Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M365.678 78C365.965 78 366.198 77.7672 366.198 77.4799C366.198 77.1926 365.965 76.9598 365.678 76.9598C365.391 76.9598 365.158 77.1926 365.158 77.4799C365.158 77.7672 365.391 78 365.678 78Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M373.554 78C373.841 78 374.074 77.7672 374.074 77.4799C374.074 77.1926 373.841 76.9598 373.554 76.9598C373.267 76.9598 373.034 77.1926 373.034 77.4799C373.034 77.7672 373.267 78 373.554 78Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M302.892 70.1981C303.179 70.1981 303.412 69.9653 303.412 69.678C303.412 69.3908 303.179 69.1579 302.892 69.1579C302.604 69.1579 302.371 69.3908 302.371 69.678C302.371 69.9653 302.604 70.1981 302.892 70.1981Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M310.768 70.1981C311.055 70.1981 311.288 69.9653 311.288 69.678C311.288 69.3908 311.055 69.1579 310.768 69.1579C310.481 69.1579 310.248 69.3908 310.248 69.678C310.248 69.9653 310.481 70.1981 310.768 70.1981Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M318.57 70.1981C318.857 70.1981 319.09 69.9653 319.09 69.678C319.09 69.3908 318.857 69.1579 318.57 69.1579C318.282 69.1579 318.049 69.3908 318.049 69.678C318.049 69.9653 318.282 70.1981 318.57 70.1981Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M326.446 70.1981C326.733 70.1981 326.966 69.9653 326.966 69.678C326.966 69.3908 326.733 69.1579 326.446 69.1579C326.159 69.1579 325.926 69.3908 325.926 69.678C325.926 69.9653 326.159 70.1981 326.446 70.1981Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M334.322 70.1981C334.609 70.1981 334.842 69.9653 334.842 69.678C334.842 69.3908 334.609 69.1579 334.322 69.1579C334.035 69.1579 333.802 69.3908 333.802 69.678C333.802 69.9653 334.035 70.1981 334.322 70.1981Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M342.124 70.1981C342.411 70.1981 342.644 69.9653 342.644 69.678C342.644 69.3908 342.411 69.1579 342.124 69.1579C341.837 69.1579 341.604 69.3908 341.604 69.678C341.604 69.9653 341.837 70.1981 342.124 70.1981Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M350 70.1981C350.287 70.1981 350.52 69.9653 350.52 69.678C350.52 69.3908 350.287 69.1579 350 69.1579C349.713 69.1579 349.48 69.3908 349.48 69.678C349.48 69.9653 349.713 70.1981 350 70.1981Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M357.802 70.1981C358.089 70.1981 358.322 69.9653 358.322 69.678C358.322 69.3908 358.089 69.1579 357.802 69.1579C357.515 69.1579 357.282 69.3908 357.282 69.678C357.282 69.9653 357.515 70.1981 357.802 70.1981Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M365.678 70.1981C365.965 70.1981 366.198 69.9653 366.198 69.678C366.198 69.3908 365.965 69.1579 365.678 69.1579C365.391 69.1579 365.158 69.3908 365.158 69.678C365.158 69.9653 365.391 70.1981 365.678 70.1981Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M373.554 70.1981C373.841 70.1981 374.074 69.9653 374.074 69.678C374.074 69.3908 373.841 69.1579 373.554 69.1579C373.267 69.1579 373.034 69.3908 373.034 69.678C373.034 69.9653 373.267 70.1981 373.554 70.1981Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M302.892 62.322C303.179 62.322 303.412 62.0891 303.412 61.8019C303.412 61.5146 303.179 61.2817 302.892 61.2817C302.604 61.2817 302.371 61.5146 302.371 61.8019C302.371 62.0891 302.604 62.322 302.892 62.322Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M310.768 62.322C311.055 62.322 311.288 62.0891 311.288 61.8019C311.288 61.5146 311.055 61.2817 310.768 61.2817C310.481 61.2817 310.248 61.5146 310.248 61.8019C310.248 62.0891 310.481 62.322 310.768 62.322Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M318.57 62.322C318.857 62.322 319.09 62.0891 319.09 61.8019C319.09 61.5146 318.857 61.2817 318.57 61.2817C318.282 61.2817 318.049 61.5146 318.049 61.8019C318.049 62.0891 318.282 62.322 318.57 62.322Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M326.446 62.322C326.733 62.322 326.966 62.0891 326.966 61.8019C326.966 61.5146 326.733 61.2817 326.446 61.2817C326.159 61.2817 325.926 61.5146 325.926 61.8019C325.926 62.0891 326.159 62.322 326.446 62.322Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M334.322 62.322C334.609 62.322 334.842 62.0891 334.842 61.8019C334.842 61.5146 334.609 61.2817 334.322 61.2817C334.035 61.2817 333.802 61.5146 333.802 61.8019C333.802 62.0891 334.035 62.322 334.322 62.322Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M342.124 62.322C342.411 62.322 342.644 62.0891 342.644 61.8019C342.644 61.5146 342.411 61.2817 342.124 61.2817C341.837 61.2817 341.604 61.5146 341.604 61.8019C341.604 62.0891 341.837 62.322 342.124 62.322Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M350 62.322C350.287 62.322 350.52 62.0891 350.52 61.8019C350.52 61.5146 350.287 61.2817 350 61.2817C349.713 61.2817 349.48 61.5146 349.48 61.8019C349.48 62.0891 349.713 62.322 350 62.322Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M357.802 62.322C358.089 62.322 358.322 62.0891 358.322 61.8019C358.322 61.5146 358.089 61.2817 357.802 61.2817C357.515 61.2817 357.282 61.5146 357.282 61.8019C357.282 62.0891 357.515 62.322 357.802 62.322Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M365.678 62.322C365.965 62.322 366.198 62.0891 366.198 61.8019C366.198 61.5146 365.965 61.2817 365.678 61.2817C365.391 61.2817 365.158 61.5146 365.158 61.8019C365.158 62.0891 365.391 62.322 365.678 62.322Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M373.554 62.322C373.841 62.322 374.074 62.0891 374.074 61.8019C374.074 61.5146 373.841 61.2817 373.554 61.2817C373.267 61.2817 373.034 61.5146 373.034 61.8019C373.034 62.0891 373.267 62.322 373.554 62.322Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M302.892 54.5201C303.179 54.5201 303.412 54.2872 303.412 54C303.412 53.7127 303.179 53.4799 302.892 53.4799C302.604 53.4799 302.371 53.7127 302.371 54C302.371 54.2872 302.604 54.5201 302.892 54.5201Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M310.768 54.5201C311.055 54.5201 311.288 54.2872 311.288 54C311.288 53.7127 311.055 53.4799 310.768 53.4799C310.481 53.4799 310.248 53.7127 310.248 54C310.248 54.2872 310.481 54.5201 310.768 54.5201Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M318.57 54.5201C318.857 54.5201 319.09 54.2872 319.09 54C319.09 53.7127 318.857 53.4799 318.57 53.4799C318.282 53.4799 318.049 53.7127 318.049 54C318.049 54.2872 318.282 54.5201 318.57 54.5201Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M326.446 54.5201C326.733 54.5201 326.966 54.2872 326.966 54C326.966 53.7127 326.733 53.4799 326.446 53.4799C326.159 53.4799 325.926 53.7127 325.926 54C325.926 54.2872 326.159 54.5201 326.446 54.5201Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M334.322 54.5201C334.609 54.5201 334.842 54.2872 334.842 54C334.842 53.7127 334.609 53.4799 334.322 53.4799C334.035 53.4799 333.802 53.7127 333.802 54C333.802 54.2872 334.035 54.5201 334.322 54.5201Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M342.124 54.5201C342.411 54.5201 342.644 54.2872 342.644 54C342.644 53.7127 342.411 53.4799 342.124 53.4799C341.837 53.4799 341.604 53.7127 341.604 54C341.604 54.2872 341.837 54.5201 342.124 54.5201Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M350 54.5201C350.287 54.5201 350.52 54.2872 350.52 54C350.52 53.7127 350.287 53.4799 350 53.4799C349.713 53.4799 349.48 53.7127 349.48 54C349.48 54.2872 349.713 54.5201 350 54.5201Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M357.802 54.5201C358.089 54.5201 358.322 54.2872 358.322 54C358.322 53.7127 358.089 53.4799 357.802 53.4799C357.515 53.4799 357.282 53.7127 357.282 54C357.282 54.2872 357.515 54.5201 357.802 54.5201Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M365.678 54.5201C365.965 54.5201 366.198 54.2872 366.198 54C366.198 53.7127 365.965 53.4799 365.678 53.4799C365.391 53.4799 365.158 53.7127 365.158 54C365.158 54.2872 365.391 54.5201 365.678 54.5201Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M373.554 54.5201C373.841 54.5201 374.074 54.2872 374.074 54C374.074 53.7127 373.841 53.4799 373.554 53.4799C373.267 53.4799 373.034 53.7127 373.034 54C373.034 54.2872 373.267 54.5201 373.554 54.5201Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M302.892 46.6439C303.179 46.6439 303.412 46.4111 303.412 46.1238C303.412 45.8366 303.179 45.6037 302.892 45.6037C302.604 45.6037 302.371 45.8366 302.371 46.1238C302.371 46.4111 302.604 46.6439 302.892 46.6439Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M310.768 46.6439C311.055 46.6439 311.288 46.4111 311.288 46.1238C311.288 45.8366 311.055 45.6037 310.768 45.6037C310.481 45.6037 310.248 45.8366 310.248 46.1238C310.248 46.4111 310.481 46.6439 310.768 46.6439Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M318.57 46.6439C318.857 46.6439 319.09 46.4111 319.09 46.1238C319.09 45.8366 318.857 45.6037 318.57 45.6037C318.282 45.6037 318.049 45.8366 318.049 46.1238C318.049 46.4111 318.282 46.6439 318.57 46.6439Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M326.446 46.6439C326.733 46.6439 326.966 46.4111 326.966 46.1238C326.966 45.8366 326.733 45.6037 326.446 45.6037C326.159 45.6037 325.926 45.8366 325.926 46.1238C325.926 46.4111 326.159 46.6439 326.446 46.6439Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M334.322 46.6439C334.609 46.6439 334.842 46.4111 334.842 46.1238C334.842 45.8366 334.609 45.6037 334.322 45.6037C334.035 45.6037 333.802 45.8366 333.802 46.1238C333.802 46.4111 334.035 46.6439 334.322 46.6439Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M342.124 46.6439C342.411 46.6439 342.644 46.4111 342.644 46.1238C342.644 45.8366 342.411 45.6037 342.124 45.6037C341.837 45.6037 341.604 45.8366 341.604 46.1238C341.604 46.4111 341.837 46.6439 342.124 46.6439Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M350 46.6439C350.287 46.6439 350.52 46.4111 350.52 46.1238C350.52 45.8366 350.287 45.6037 350 45.6037C349.713 45.6037 349.48 45.8366 349.48 46.1238C349.48 46.4111 349.713 46.6439 350 46.6439Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M357.802 46.6439C358.089 46.6439 358.322 46.4111 358.322 46.1238C358.322 45.8366 358.089 45.6037 357.802 45.6037C357.515 45.6037 357.282 45.8366 357.282 46.1238C357.282 46.4111 357.515 46.6439 357.802 46.6439Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M365.678 46.6439C365.965 46.6439 366.198 46.4111 366.198 46.1238C366.198 45.8366 365.965 45.6037 365.678 45.6037C365.391 45.6037 365.158 45.8366 365.158 46.1238C365.158 46.4111 365.391 46.6439 365.678 46.6439Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M373.554 46.6439C373.841 46.6439 374.074 46.4111 374.074 46.1238C374.074 45.8366 373.841 45.6037 373.554 45.6037C373.267 45.6037 373.034 45.8366 373.034 46.1238C373.034 46.4111 373.267 46.6439 373.554 46.6439Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M302.892 38.8421C303.179 38.8421 303.412 38.6093 303.412 38.322C303.412 38.0347 303.179 37.8019 302.892 37.8019C302.604 37.8019 302.371 38.0347 302.371 38.322C302.371 38.6093 302.604 38.8421 302.892 38.8421Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M310.768 38.8421C311.055 38.8421 311.288 38.6093 311.288 38.322C311.288 38.0347 311.055 37.8019 310.768 37.8019C310.481 37.8019 310.248 38.0347 310.248 38.322C310.248 38.6093 310.481 38.8421 310.768 38.8421Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M318.57 38.8421C318.857 38.8421 319.09 38.6093 319.09 38.322C319.09 38.0347 318.857 37.8019 318.57 37.8019C318.282 37.8019 318.049 38.0347 318.049 38.322C318.049 38.6093 318.282 38.8421 318.57 38.8421Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M326.446 38.8421C326.733 38.8421 326.966 38.6093 326.966 38.322C326.966 38.0347 326.733 37.8019 326.446 37.8019C326.159 37.8019 325.926 38.0347 325.926 38.322C325.926 38.6093 326.159 38.8421 326.446 38.8421Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M334.322 38.8421C334.609 38.8421 334.842 38.6093 334.842 38.322C334.842 38.0347 334.609 37.8019 334.322 37.8019C334.035 37.8019 333.802 38.0347 333.802 38.322C333.802 38.6093 334.035 38.8421 334.322 38.8421Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M342.124 38.8421C342.411 38.8421 342.644 38.6093 342.644 38.322C342.644 38.0347 342.411 37.8019 342.124 37.8019C341.837 37.8019 341.604 38.0347 341.604 38.322C341.604 38.6093 341.837 38.8421 342.124 38.8421Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M350 38.8421C350.287 38.8421 350.52 38.6093 350.52 38.322C350.52 38.0347 350.287 37.8019 350 37.8019C349.713 37.8019 349.48 38.0347 349.48 38.322C349.48 38.6093 349.713 38.8421 350 38.8421Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M357.802 38.8421C358.089 38.8421 358.322 38.6093 358.322 38.322C358.322 38.0347 358.089 37.8019 357.802 37.8019C357.515 37.8019 357.282 38.0347 357.282 38.322C357.282 38.6093 357.515 38.8421 357.802 38.8421Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M365.678 38.8421C365.965 38.8421 366.198 38.6093 366.198 38.322C366.198 38.0347 365.965 37.8019 365.678 37.8019C365.391 37.8019 365.158 38.0347 365.158 38.322C365.158 38.6093 365.391 38.8421 365.678 38.8421Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M373.554 38.8421C373.841 38.8421 374.074 38.6093 374.074 38.322C374.074 38.0347 373.841 37.8019 373.554 37.8019C373.267 37.8019 373.034 38.0347 373.034 38.322C373.034 38.6093 373.267 38.8421 373.554 38.8421Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M302.892 30.966C303.179 30.966 303.412 30.7331 303.412 30.4458C303.412 30.1586 303.179 29.9257 302.892 29.9257C302.604 29.9257 302.371 30.1586 302.371 30.4458C302.371 30.7331 302.604 30.966 302.892 30.966Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M310.768 30.966C311.055 30.966 311.288 30.7331 311.288 30.4458C311.288 30.1586 311.055 29.9257 310.768 29.9257C310.481 29.9257 310.248 30.1586 310.248 30.4458C310.248 30.7331 310.481 30.966 310.768 30.966Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M318.57 30.966C318.857 30.966 319.09 30.7331 319.09 30.4458C319.09 30.1586 318.857 29.9257 318.57 29.9257C318.282 29.9257 318.049 30.1586 318.049 30.4458C318.049 30.7331 318.282 30.966 318.57 30.966Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M326.446 30.966C326.733 30.966 326.966 30.7331 326.966 30.4458C326.966 30.1586 326.733 29.9257 326.446 29.9257C326.159 29.9257 325.926 30.1586 325.926 30.4458C325.926 30.7331 326.159 30.966 326.446 30.966Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M334.322 30.966C334.609 30.966 334.842 30.7331 334.842 30.4458C334.842 30.1586 334.609 29.9257 334.322 29.9257C334.035 29.9257 333.802 30.1586 333.802 30.4458C333.802 30.7331 334.035 30.966 334.322 30.966Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M342.124 30.966C342.411 30.966 342.644 30.7331 342.644 30.4458C342.644 30.1586 342.411 29.9257 342.124 29.9257C341.837 29.9257 341.604 30.1586 341.604 30.4458C341.604 30.7331 341.837 30.966 342.124 30.966Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M350 30.966C350.287 30.966 350.52 30.7331 350.52 30.4458C350.52 30.1586 350.287 29.9257 350 29.9257C349.713 29.9257 349.48 30.1586 349.48 30.4458C349.48 30.7331 349.713 30.966 350 30.966Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M357.802 30.966C358.089 30.966 358.322 30.7331 358.322 30.4458C358.322 30.1586 358.089 29.9257 357.802 29.9257C357.515 29.9257 357.282 30.1586 357.282 30.4458C357.282 30.7331 357.515 30.966 357.802 30.966Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M365.678 30.966C365.965 30.966 366.198 30.7331 366.198 30.4458C366.198 30.1586 365.965 29.9257 365.678 29.9257C365.391 29.9257 365.158 30.1586 365.158 30.4458C365.158 30.7331 365.391 30.966 365.678 30.966Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M373.554 30.966C373.841 30.966 374.074 30.7331 374.074 30.4458C374.074 30.1586 373.841 29.9257 373.554 29.9257C373.267 29.9257 373.034 30.1586 373.034 30.4458C373.034 30.7331 373.267 30.966 373.554 30.966Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M302.892 23.0898C303.179 23.0898 303.412 22.8569 303.412 22.5697C303.412 22.2824 303.179 22.0496 302.892 22.0496C302.604 22.0496 302.371 22.2824 302.371 22.5697C302.371 22.8569 302.604 23.0898 302.892 23.0898Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M310.768 23.0898C311.055 23.0898 311.288 22.8569 311.288 22.5697C311.288 22.2824 311.055 22.0496 310.768 22.0496C310.481 22.0496 310.248 22.2824 310.248 22.5697C310.248 22.8569 310.481 23.0898 310.768 23.0898Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M318.57 23.0898C318.857 23.0898 319.09 22.8569 319.09 22.5697C319.09 22.2824 318.857 22.0496 318.57 22.0496C318.282 22.0496 318.049 22.2824 318.049 22.5697C318.049 22.8569 318.282 23.0898 318.57 23.0898Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M326.446 23.0898C326.733 23.0898 326.966 22.8569 326.966 22.5697C326.966 22.2824 326.733 22.0496 326.446 22.0496C326.159 22.0496 325.926 22.2824 325.926 22.5697C325.926 22.8569 326.159 23.0898 326.446 23.0898Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M334.322 23.0898C334.609 23.0898 334.842 22.8569 334.842 22.5697C334.842 22.2824 334.609 22.0496 334.322 22.0496C334.035 22.0496 333.802 22.2824 333.802 22.5697C333.802 22.8569 334.035 23.0898 334.322 23.0898Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M342.124 23.0898C342.411 23.0898 342.644 22.8569 342.644 22.5697C342.644 22.2824 342.411 22.0496 342.124 22.0496C341.837 22.0496 341.604 22.2824 341.604 22.5697C341.604 22.8569 341.837 23.0898 342.124 23.0898Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M350 23.0898C350.287 23.0898 350.52 22.8569 350.52 22.5697C350.52 22.2824 350.287 22.0496 350 22.0496C349.713 22.0496 349.48 22.2824 349.48 22.5697C349.48 22.8569 349.713 23.0898 350 23.0898Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M357.802 23.0898C358.089 23.0898 358.322 22.8569 358.322 22.5697C358.322 22.2824 358.089 22.0496 357.802 22.0496C357.515 22.0496 357.282 22.2824 357.282 22.5697C357.282 22.8569 357.515 23.0898 357.802 23.0898Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M365.678 23.0898C365.965 23.0898 366.198 22.8569 366.198 22.5697C366.198 22.2824 365.965 22.0496 365.678 22.0496C365.391 22.0496 365.158 22.2824 365.158 22.5697C365.158 22.8569 365.391 23.0898 365.678 23.0898Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M373.554 23.0898C373.841 23.0898 374.074 22.8569 374.074 22.5697C374.074 22.2824 373.841 22.0496 373.554 22.0496C373.267 22.0496 373.034 22.2824 373.034 22.5697C373.034 22.8569 373.267 23.0898 373.554 23.0898Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M302.892 15.2879C303.179 15.2879 303.412 15.0551 303.412 14.7678C303.412 14.4805 303.179 14.2477 302.892 14.2477C302.604 14.2477 302.371 14.4805 302.371 14.7678C302.371 15.0551 302.604 15.2879 302.892 15.2879Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M310.768 15.2879C311.055 15.2879 311.288 15.0551 311.288 14.7678C311.288 14.4805 311.055 14.2477 310.768 14.2477C310.481 14.2477 310.248 14.4805 310.248 14.7678C310.248 15.0551 310.481 15.2879 310.768 15.2879Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M318.57 15.2879C318.857 15.2879 319.09 15.0551 319.09 14.7678C319.09 14.4805 318.857 14.2477 318.57 14.2477C318.282 14.2477 318.049 14.4805 318.049 14.7678C318.049 15.0551 318.282 15.2879 318.57 15.2879Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M326.446 15.2879C326.733 15.2879 326.966 15.0551 326.966 14.7678C326.966 14.4805 326.733 14.2477 326.446 14.2477C326.159 14.2477 325.926 14.4805 325.926 14.7678C325.926 15.0551 326.159 15.2879 326.446 15.2879Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M334.322 15.2879C334.609 15.2879 334.842 15.0551 334.842 14.7678C334.842 14.4805 334.609 14.2477 334.322 14.2477C334.035 14.2477 333.802 14.4805 333.802 14.7678C333.802 15.0551 334.035 15.2879 334.322 15.2879Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M342.124 15.2879C342.411 15.2879 342.644 15.0551 342.644 14.7678C342.644 14.4805 342.411 14.2477 342.124 14.2477C341.837 14.2477 341.604 14.4805 341.604 14.7678C341.604 15.0551 341.837 15.2879 342.124 15.2879Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M350 15.2879C350.287 15.2879 350.52 15.0551 350.52 14.7678C350.52 14.4805 350.287 14.2477 350 14.2477C349.713 14.2477 349.48 14.4805 349.48 14.7678C349.48 15.0551 349.713 15.2879 350 15.2879Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M357.802 15.2879C358.089 15.2879 358.322 15.0551 358.322 14.7678C358.322 14.4805 358.089 14.2477 357.802 14.2477C357.515 14.2477 357.282 14.4805 357.282 14.7678C357.282 15.0551 357.515 15.2879 357.802 15.2879Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M365.678 15.2879C365.965 15.2879 366.198 15.0551 366.198 14.7678C366.198 14.4805 365.965 14.2477 365.678 14.2477C365.391 14.2477 365.158 14.4805 365.158 14.7678C365.158 15.0551 365.391 15.2879 365.678 15.2879Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M373.554 15.2879C373.841 15.2879 374.074 15.0551 374.074 14.7678C374.074 14.4805 373.841 14.2477 373.554 14.2477C373.267 14.2477 373.034 14.4805 373.034 14.7678C373.034 15.0551 373.267 15.2879 373.554 15.2879Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M302.892 7.41177C303.179 7.41177 303.412 7.1789 303.412 6.89164C303.412 6.60439 303.179 6.37152 302.892 6.37152C302.604 6.37152 302.371 6.60439 302.371 6.89164C302.371 7.1789 302.604 7.41177 302.892 7.41177Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M310.768 7.41177C311.055 7.41177 311.288 7.1789 311.288 6.89164C311.288 6.60439 311.055 6.37152 310.768 6.37152C310.481 6.37152 310.248 6.60439 310.248 6.89164C310.248 7.1789 310.481 7.41177 310.768 7.41177Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M318.57 7.41177C318.857 7.41177 319.09 7.1789 319.09 6.89164C319.09 6.60439 318.857 6.37152 318.57 6.37152C318.282 6.37152 318.049 6.60439 318.049 6.89164C318.049 7.1789 318.282 7.41177 318.57 7.41177Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M326.446 7.41177C326.733 7.41177 326.966 7.1789 326.966 6.89164C326.966 6.60439 326.733 6.37152 326.446 6.37152C326.159 6.37152 325.926 6.60439 325.926 6.89164C325.926 7.1789 326.159 7.41177 326.446 7.41177Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M334.322 7.41177C334.609 7.41177 334.842 7.1789 334.842 6.89164C334.842 6.60439 334.609 6.37152 334.322 6.37152C334.035 6.37152 333.802 6.60439 333.802 6.89164C333.802 7.1789 334.035 7.41177 334.322 7.41177Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M342.124 7.41177C342.411 7.41177 342.644 7.1789 342.644 6.89164C342.644 6.60439 342.411 6.37152 342.124 6.37152C341.837 6.37152 341.604 6.60439 341.604 6.89164C341.604 7.1789 341.837 7.41177 342.124 7.41177Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M350 7.41177C350.287 7.41177 350.52 7.1789 350.52 6.89164C350.52 6.60439 350.287 6.37152 350 6.37152C349.713 6.37152 349.48 6.60439 349.48 6.89164C349.48 7.1789 349.713 7.41177 350 7.41177Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M357.802 7.41177C358.089 7.41177 358.322 7.1789 358.322 6.89164C358.322 6.60439 358.089 6.37152 357.802 6.37152C357.515 6.37152 357.282 6.60439 357.282 6.89164C357.282 7.1789 357.515 7.41177 357.802 7.41177Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M365.678 7.41177C365.965 7.41177 366.198 7.1789 366.198 6.89164C366.198 6.60439 365.965 6.37152 365.678 6.37152C365.391 6.37152 365.158 6.60439 365.158 6.89164C365.158 7.1789 365.391 7.41177 365.678 7.41177Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M373.554 7.41177C373.841 7.41177 374.074 7.1789 374.074 6.89164C374.074 6.60439 373.841 6.37152 373.554 6.37152C373.267 6.37152 373.034 6.60439 373.034 6.89164C373.034 7.1789 373.267 7.41177 373.554 7.41177Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    clipPath: "url(#clip1_862_5384)"
  }, _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M302.892 163.322C303.179 163.322 303.412 163.089 303.412 162.802C303.412 162.515 303.179 162.282 302.892 162.282C302.604 162.282 302.371 162.515 302.371 162.802C302.371 163.089 302.604 163.322 302.892 163.322Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M310.768 163.322C311.055 163.322 311.288 163.089 311.288 162.802C311.288 162.515 311.055 162.282 310.768 162.282C310.481 162.282 310.248 162.515 310.248 162.802C310.248 163.089 310.481 163.322 310.768 163.322Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M318.57 163.322C318.857 163.322 319.09 163.089 319.09 162.802C319.09 162.515 318.857 162.282 318.57 162.282C318.282 162.282 318.049 162.515 318.049 162.802C318.049 163.089 318.282 163.322 318.57 163.322Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M326.446 163.322C326.733 163.322 326.966 163.089 326.966 162.802C326.966 162.515 326.733 162.282 326.446 162.282C326.159 162.282 325.926 162.515 325.926 162.802C325.926 163.089 326.159 163.322 326.446 163.322Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M334.322 163.322C334.609 163.322 334.842 163.089 334.842 162.802C334.842 162.515 334.609 162.282 334.322 162.282C334.035 162.282 333.802 162.515 333.802 162.802C333.802 163.089 334.035 163.322 334.322 163.322Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M342.124 163.322C342.411 163.322 342.644 163.089 342.644 162.802C342.644 162.515 342.411 162.282 342.124 162.282C341.837 162.282 341.604 162.515 341.604 162.802C341.604 163.089 341.837 163.322 342.124 163.322Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M350 163.322C350.287 163.322 350.52 163.089 350.52 162.802C350.52 162.515 350.287 162.282 350 162.282C349.713 162.282 349.48 162.515 349.48 162.802C349.48 163.089 349.713 163.322 350 163.322Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M357.802 163.322C358.089 163.322 358.322 163.089 358.322 162.802C358.322 162.515 358.089 162.282 357.802 162.282C357.515 162.282 357.282 162.515 357.282 162.802C357.282 163.089 357.515 163.322 357.802 163.322Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M365.678 163.322C365.965 163.322 366.198 163.089 366.198 162.802C366.198 162.515 365.965 162.282 365.678 162.282C365.391 162.282 365.158 162.515 365.158 162.802C365.158 163.089 365.391 163.322 365.678 163.322Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M373.554 163.322C373.841 163.322 374.074 163.089 374.074 162.802C374.074 162.515 373.841 162.282 373.554 162.282C373.267 162.282 373.034 162.515 373.034 162.802C373.034 163.089 373.267 163.322 373.554 163.322Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M302.892 155.52C303.179 155.52 303.412 155.287 303.412 155C303.412 154.713 303.179 154.48 302.892 154.48C302.604 154.48 302.371 154.713 302.371 155C302.371 155.287 302.604 155.52 302.892 155.52Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M310.768 155.52C311.055 155.52 311.288 155.287 311.288 155C311.288 154.713 311.055 154.48 310.768 154.48C310.481 154.48 310.248 154.713 310.248 155C310.248 155.287 310.481 155.52 310.768 155.52Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M318.57 155.52C318.857 155.52 319.09 155.287 319.09 155C319.09 154.713 318.857 154.48 318.57 154.48C318.282 154.48 318.049 154.713 318.049 155C318.049 155.287 318.282 155.52 318.57 155.52Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M326.446 155.52C326.733 155.52 326.966 155.287 326.966 155C326.966 154.713 326.733 154.48 326.446 154.48C326.159 154.48 325.926 154.713 325.926 155C325.926 155.287 326.159 155.52 326.446 155.52Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M334.322 155.52C334.609 155.52 334.842 155.287 334.842 155C334.842 154.713 334.609 154.48 334.322 154.48C334.035 154.48 333.802 154.713 333.802 155C333.802 155.287 334.035 155.52 334.322 155.52Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M342.124 155.52C342.411 155.52 342.644 155.287 342.644 155C342.644 154.713 342.411 154.48 342.124 154.48C341.837 154.48 341.604 154.713 341.604 155C341.604 155.287 341.837 155.52 342.124 155.52Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M350 155.52C350.287 155.52 350.52 155.287 350.52 155C350.52 154.713 350.287 154.48 350 154.48C349.713 154.48 349.48 154.713 349.48 155C349.48 155.287 349.713 155.52 350 155.52Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M357.802 155.52C358.089 155.52 358.322 155.287 358.322 155C358.322 154.713 358.089 154.48 357.802 154.48C357.515 154.48 357.282 154.713 357.282 155C357.282 155.287 357.515 155.52 357.802 155.52Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M365.678 155.52C365.965 155.52 366.198 155.287 366.198 155C366.198 154.713 365.965 154.48 365.678 154.48C365.391 154.48 365.158 154.713 365.158 155C365.158 155.287 365.391 155.52 365.678 155.52Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M373.554 155.52C373.841 155.52 374.074 155.287 374.074 155C374.074 154.713 373.841 154.48 373.554 154.48C373.267 154.48 373.034 154.713 373.034 155C373.034 155.287 373.267 155.52 373.554 155.52Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M302.892 147.644C303.179 147.644 303.412 147.411 303.412 147.124C303.412 146.837 303.179 146.604 302.892 146.604C302.604 146.604 302.371 146.837 302.371 147.124C302.371 147.411 302.604 147.644 302.892 147.644Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M310.768 147.644C311.055 147.644 311.288 147.411 311.288 147.124C311.288 146.837 311.055 146.604 310.768 146.604C310.481 146.604 310.248 146.837 310.248 147.124C310.248 147.411 310.481 147.644 310.768 147.644Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M318.57 147.644C318.857 147.644 319.09 147.411 319.09 147.124C319.09 146.837 318.857 146.604 318.57 146.604C318.282 146.604 318.049 146.837 318.049 147.124C318.049 147.411 318.282 147.644 318.57 147.644Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M326.446 147.644C326.733 147.644 326.966 147.411 326.966 147.124C326.966 146.837 326.733 146.604 326.446 146.604C326.159 146.604 325.926 146.837 325.926 147.124C325.926 147.411 326.159 147.644 326.446 147.644Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M334.322 147.644C334.609 147.644 334.842 147.411 334.842 147.124C334.842 146.837 334.609 146.604 334.322 146.604C334.035 146.604 333.802 146.837 333.802 147.124C333.802 147.411 334.035 147.644 334.322 147.644Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M342.124 147.644C342.411 147.644 342.644 147.411 342.644 147.124C342.644 146.837 342.411 146.604 342.124 146.604C341.837 146.604 341.604 146.837 341.604 147.124C341.604 147.411 341.837 147.644 342.124 147.644Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M350 147.644C350.287 147.644 350.52 147.411 350.52 147.124C350.52 146.837 350.287 146.604 350 146.604C349.713 146.604 349.48 146.837 349.48 147.124C349.48 147.411 349.713 147.644 350 147.644Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M357.802 147.644C358.089 147.644 358.322 147.411 358.322 147.124C358.322 146.837 358.089 146.604 357.802 146.604C357.515 146.604 357.282 146.837 357.282 147.124C357.282 147.411 357.515 147.644 357.802 147.644Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M365.678 147.644C365.965 147.644 366.198 147.411 366.198 147.124C366.198 146.837 365.965 146.604 365.678 146.604C365.391 146.604 365.158 146.837 365.158 147.124C365.158 147.411 365.391 147.644 365.678 147.644Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M373.554 147.644C373.841 147.644 374.074 147.411 374.074 147.124C374.074 146.837 373.841 146.604 373.554 146.604C373.267 146.604 373.034 146.837 373.034 147.124C373.034 147.411 373.267 147.644 373.554 147.644Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M302.892 139.842C303.179 139.842 303.412 139.609 303.412 139.322C303.412 139.035 303.179 138.802 302.892 138.802C302.604 138.802 302.371 139.035 302.371 139.322C302.371 139.609 302.604 139.842 302.892 139.842Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M310.768 139.842C311.055 139.842 311.288 139.609 311.288 139.322C311.288 139.035 311.055 138.802 310.768 138.802C310.481 138.802 310.248 139.035 310.248 139.322C310.248 139.609 310.481 139.842 310.768 139.842Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M318.57 139.842C318.857 139.842 319.09 139.609 319.09 139.322C319.09 139.035 318.857 138.802 318.57 138.802C318.282 138.802 318.049 139.035 318.049 139.322C318.049 139.609 318.282 139.842 318.57 139.842Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M326.446 139.842C326.733 139.842 326.966 139.609 326.966 139.322C326.966 139.035 326.733 138.802 326.446 138.802C326.159 138.802 325.926 139.035 325.926 139.322C325.926 139.609 326.159 139.842 326.446 139.842Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M334.322 139.842C334.609 139.842 334.842 139.609 334.842 139.322C334.842 139.035 334.609 138.802 334.322 138.802C334.035 138.802 333.802 139.035 333.802 139.322C333.802 139.609 334.035 139.842 334.322 139.842Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M342.124 139.842C342.411 139.842 342.644 139.609 342.644 139.322C342.644 139.035 342.411 138.802 342.124 138.802C341.837 138.802 341.604 139.035 341.604 139.322C341.604 139.609 341.837 139.842 342.124 139.842Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M350 139.842C350.287 139.842 350.52 139.609 350.52 139.322C350.52 139.035 350.287 138.802 350 138.802C349.713 138.802 349.48 139.035 349.48 139.322C349.48 139.609 349.713 139.842 350 139.842Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M357.802 139.842C358.089 139.842 358.322 139.609 358.322 139.322C358.322 139.035 358.089 138.802 357.802 138.802C357.515 138.802 357.282 139.035 357.282 139.322C357.282 139.609 357.515 139.842 357.802 139.842Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M365.678 139.842C365.965 139.842 366.198 139.609 366.198 139.322C366.198 139.035 365.965 138.802 365.678 138.802C365.391 138.802 365.158 139.035 365.158 139.322C365.158 139.609 365.391 139.842 365.678 139.842Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M373.554 139.842C373.841 139.842 374.074 139.609 374.074 139.322C374.074 139.035 373.841 138.802 373.554 138.802C373.267 138.802 373.034 139.035 373.034 139.322C373.034 139.609 373.267 139.842 373.554 139.842Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M302.892 131.966C303.179 131.966 303.412 131.733 303.412 131.446C303.412 131.159 303.179 130.926 302.892 130.926C302.604 130.926 302.371 131.159 302.371 131.446C302.371 131.733 302.604 131.966 302.892 131.966Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M310.768 131.966C311.055 131.966 311.288 131.733 311.288 131.446C311.288 131.159 311.055 130.926 310.768 130.926C310.481 130.926 310.248 131.159 310.248 131.446C310.248 131.733 310.481 131.966 310.768 131.966Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M318.57 131.966C318.857 131.966 319.09 131.733 319.09 131.446C319.09 131.159 318.857 130.926 318.57 130.926C318.282 130.926 318.049 131.159 318.049 131.446C318.049 131.733 318.282 131.966 318.57 131.966Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M326.446 131.966C326.733 131.966 326.966 131.733 326.966 131.446C326.966 131.159 326.733 130.926 326.446 130.926C326.159 130.926 325.926 131.159 325.926 131.446C325.926 131.733 326.159 131.966 326.446 131.966Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M334.322 131.966C334.609 131.966 334.842 131.733 334.842 131.446C334.842 131.159 334.609 130.926 334.322 130.926C334.035 130.926 333.802 131.159 333.802 131.446C333.802 131.733 334.035 131.966 334.322 131.966Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M342.124 131.966C342.411 131.966 342.644 131.733 342.644 131.446C342.644 131.159 342.411 130.926 342.124 130.926C341.837 130.926 341.604 131.159 341.604 131.446C341.604 131.733 341.837 131.966 342.124 131.966Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M350 131.966C350.287 131.966 350.52 131.733 350.52 131.446C350.52 131.159 350.287 130.926 350 130.926C349.713 130.926 349.48 131.159 349.48 131.446C349.48 131.733 349.713 131.966 350 131.966Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M357.802 131.966C358.089 131.966 358.322 131.733 358.322 131.446C358.322 131.159 358.089 130.926 357.802 130.926C357.515 130.926 357.282 131.159 357.282 131.446C357.282 131.733 357.515 131.966 357.802 131.966Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M365.678 131.966C365.965 131.966 366.198 131.733 366.198 131.446C366.198 131.159 365.965 130.926 365.678 130.926C365.391 130.926 365.158 131.159 365.158 131.446C365.158 131.733 365.391 131.966 365.678 131.966Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M373.554 131.966C373.841 131.966 374.074 131.733 374.074 131.446C374.074 131.159 373.841 130.926 373.554 130.926C373.267 130.926 373.034 131.159 373.034 131.446C373.034 131.733 373.267 131.966 373.554 131.966Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M302.892 124.09C303.179 124.09 303.412 123.857 303.412 123.57C303.412 123.282 303.179 123.05 302.892 123.05C302.604 123.05 302.371 123.282 302.371 123.57C302.371 123.857 302.604 124.09 302.892 124.09Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M310.768 124.09C311.055 124.09 311.288 123.857 311.288 123.57C311.288 123.282 311.055 123.05 310.768 123.05C310.481 123.05 310.248 123.282 310.248 123.57C310.248 123.857 310.481 124.09 310.768 124.09Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M318.57 124.09C318.857 124.09 319.09 123.857 319.09 123.57C319.09 123.282 318.857 123.05 318.57 123.05C318.282 123.05 318.049 123.282 318.049 123.57C318.049 123.857 318.282 124.09 318.57 124.09Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M326.446 124.09C326.733 124.09 326.966 123.857 326.966 123.57C326.966 123.282 326.733 123.05 326.446 123.05C326.159 123.05 325.926 123.282 325.926 123.57C325.926 123.857 326.159 124.09 326.446 124.09Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M334.322 124.09C334.609 124.09 334.842 123.857 334.842 123.57C334.842 123.282 334.609 123.05 334.322 123.05C334.035 123.05 333.802 123.282 333.802 123.57C333.802 123.857 334.035 124.09 334.322 124.09Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M342.124 124.09C342.411 124.09 342.644 123.857 342.644 123.57C342.644 123.282 342.411 123.05 342.124 123.05C341.837 123.05 341.604 123.282 341.604 123.57C341.604 123.857 341.837 124.09 342.124 124.09Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M350 124.09C350.287 124.09 350.52 123.857 350.52 123.57C350.52 123.282 350.287 123.05 350 123.05C349.713 123.05 349.48 123.282 349.48 123.57C349.48 123.857 349.713 124.09 350 124.09Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M357.802 124.09C358.089 124.09 358.322 123.857 358.322 123.57C358.322 123.282 358.089 123.05 357.802 123.05C357.515 123.05 357.282 123.282 357.282 123.57C357.282 123.857 357.515 124.09 357.802 124.09Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M365.678 124.09C365.965 124.09 366.198 123.857 366.198 123.57C366.198 123.282 365.965 123.05 365.678 123.05C365.391 123.05 365.158 123.282 365.158 123.57C365.158 123.857 365.391 124.09 365.678 124.09Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M373.554 124.09C373.841 124.09 374.074 123.857 374.074 123.57C374.074 123.282 373.841 123.05 373.554 123.05C373.267 123.05 373.034 123.282 373.034 123.57C373.034 123.857 373.267 124.09 373.554 124.09Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M302.892 116.288C303.179 116.288 303.412 116.055 303.412 115.768C303.412 115.481 303.179 115.248 302.892 115.248C302.604 115.248 302.371 115.481 302.371 115.768C302.371 116.055 302.604 116.288 302.892 116.288Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M310.768 116.288C311.055 116.288 311.288 116.055 311.288 115.768C311.288 115.481 311.055 115.248 310.768 115.248C310.481 115.248 310.248 115.481 310.248 115.768C310.248 116.055 310.481 116.288 310.768 116.288Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M318.57 116.288C318.857 116.288 319.09 116.055 319.09 115.768C319.09 115.481 318.857 115.248 318.57 115.248C318.282 115.248 318.049 115.481 318.049 115.768C318.049 116.055 318.282 116.288 318.57 116.288Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M326.446 116.288C326.733 116.288 326.966 116.055 326.966 115.768C326.966 115.481 326.733 115.248 326.446 115.248C326.159 115.248 325.926 115.481 325.926 115.768C325.926 116.055 326.159 116.288 326.446 116.288Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M334.322 116.288C334.609 116.288 334.842 116.055 334.842 115.768C334.842 115.481 334.609 115.248 334.322 115.248C334.035 115.248 333.802 115.481 333.802 115.768C333.802 116.055 334.035 116.288 334.322 116.288Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M342.124 116.288C342.411 116.288 342.644 116.055 342.644 115.768C342.644 115.481 342.411 115.248 342.124 115.248C341.837 115.248 341.604 115.481 341.604 115.768C341.604 116.055 341.837 116.288 342.124 116.288Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M350 116.288C350.287 116.288 350.52 116.055 350.52 115.768C350.52 115.481 350.287 115.248 350 115.248C349.713 115.248 349.48 115.481 349.48 115.768C349.48 116.055 349.713 116.288 350 116.288Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M357.802 116.288C358.089 116.288 358.322 116.055 358.322 115.768C358.322 115.481 358.089 115.248 357.802 115.248C357.515 115.248 357.282 115.481 357.282 115.768C357.282 116.055 357.515 116.288 357.802 116.288Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M365.678 116.288C365.965 116.288 366.198 116.055 366.198 115.768C366.198 115.481 365.965 115.248 365.678 115.248C365.391 115.248 365.158 115.481 365.158 115.768C365.158 116.055 365.391 116.288 365.678 116.288Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M373.554 116.288C373.841 116.288 374.074 116.055 374.074 115.768C374.074 115.481 373.841 115.248 373.554 115.248C373.267 115.248 373.034 115.481 373.034 115.768C373.034 116.055 373.267 116.288 373.554 116.288Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M302.892 108.412C303.179 108.412 303.412 108.179 303.412 107.892C303.412 107.604 303.179 107.372 302.892 107.372C302.604 107.372 302.371 107.604 302.371 107.892C302.371 108.179 302.604 108.412 302.892 108.412Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M310.768 108.412C311.055 108.412 311.288 108.179 311.288 107.892C311.288 107.604 311.055 107.372 310.768 107.372C310.481 107.372 310.248 107.604 310.248 107.892C310.248 108.179 310.481 108.412 310.768 108.412Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M318.57 108.412C318.857 108.412 319.09 108.179 319.09 107.892C319.09 107.604 318.857 107.372 318.57 107.372C318.282 107.372 318.049 107.604 318.049 107.892C318.049 108.179 318.282 108.412 318.57 108.412Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M326.446 108.412C326.733 108.412 326.966 108.179 326.966 107.892C326.966 107.604 326.733 107.372 326.446 107.372C326.159 107.372 325.926 107.604 325.926 107.892C325.926 108.179 326.159 108.412 326.446 108.412Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M334.322 108.412C334.609 108.412 334.842 108.179 334.842 107.892C334.842 107.604 334.609 107.372 334.322 107.372C334.035 107.372 333.802 107.604 333.802 107.892C333.802 108.179 334.035 108.412 334.322 108.412Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M342.124 108.412C342.411 108.412 342.644 108.179 342.644 107.892C342.644 107.604 342.411 107.372 342.124 107.372C341.837 107.372 341.604 107.604 341.604 107.892C341.604 108.179 341.837 108.412 342.124 108.412Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M350 108.412C350.287 108.412 350.52 108.179 350.52 107.892C350.52 107.604 350.287 107.372 350 107.372C349.713 107.372 349.48 107.604 349.48 107.892C349.48 108.179 349.713 108.412 350 108.412Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M357.802 108.412C358.089 108.412 358.322 108.179 358.322 107.892C358.322 107.604 358.089 107.372 357.802 107.372C357.515 107.372 357.282 107.604 357.282 107.892C357.282 108.179 357.515 108.412 357.802 108.412Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M365.678 108.412C365.965 108.412 366.198 108.179 366.198 107.892C366.198 107.604 365.965 107.372 365.678 107.372C365.391 107.372 365.158 107.604 365.158 107.892C365.158 108.179 365.391 108.412 365.678 108.412Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M373.554 108.412C373.841 108.412 374.074 108.179 374.074 107.892C374.074 107.604 373.841 107.372 373.554 107.372C373.267 107.372 373.034 107.604 373.034 107.892C373.034 108.179 373.267 108.412 373.554 108.412Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_862_5384"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "white",
    transform: "translate(302 6)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_862_5384"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 60,
    fill: "white",
    transform: "translate(302 107)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLearnBg3);
export default __webpack_public_path__ + "static/media/learn-bg-3.4ba0c3b7b2f37ca84fb73b70bd1474a7.svg";
export { ForwardRef as ReactComponent };